import React from 'react';
import { buscarFormulariosPorCPFPorPagina } from '../actions/FormActions';
import { formatLongToDate } from '../../../helpers/Data';
import {View, LinkAction, Table, TableColumn} from 'react-template';

class ListAllForm extends View {

    constructor(props) {
        super(props);
        this.state = { 
            data: null,
            url: '/forms',
            camposFiltrando: '',
            activeLoader: true,
        };
    }

    formatData(resData){
        let content = [];
        resData.content.forEach(item => {
            let id = item.id;
            let titulo = JSON.parse(item.formEditavel).titulo;
            let dataCriacao = item.dataCriacao;
            let dataInicio = item.dataInicio
            let dataValidade = item.dataValidade
            content.push({id, titulo, dataCriacao, dataInicio, dataValidade});
        });
        resData.content = content;
        return resData;
    }

    componentDidMount() {
        this.getForms(this.state.url + '?size=10');
    }

    onPaginator = (url) => {
        this.getForms(url + this.state.camposFiltrando)
    }

    onFilter = (camposFiltrando) => {
        const url = this.state.url + '?size=10' + camposFiltrando
        this.setState({camposFiltrando});
        this.getForms(url, true);
    };

    getForms = (url, filtrando = false) => {
        buscarFormulariosPorCPFPorPagina(url, res => {
            if(filtrando && res.data.numberOfElements === 0){
                this.setState({camposFiltrando: ''})
                this.noResultOnFilter();
                return;
            }
            const resData = this.formatData(res.data);
            this.setState({ data: resData,
                activeLoader: false});
        }, error => {
            this.setState({activeLoader: false});
            this.notifyError("Erro ao carregar formulários", "");
        });
    }

    dataMapper = (data) => {
        return (
            <tr key={data.id}>
                <TableColumn width="70" headers="titulo" content={data.titulo} label="Titulo" filter={{atributo: 'titulo', coluna: 'Título', tipo: 'String'}}/>
                <TableColumn width="10" headers="dataCriacao" content={formatLongToDate(data.dataCriacao)} label="Criação" limit="10" filter={{atributo: 'dataCriacao', coluna: 'Data de criação', tipo: 'Date'}}/>
                <TableColumn width="10" headers="dataInicio" content={formatLongToDate(data.dataInicio)} label="Data Início" />
                <TableColumn width="10" headers="dataValidade" content={formatLongToDate(data.dataValidade)} label="Data Validade" filter={{atributo: 'dataValidade', coluna: 'Data de validade', tipo: 'Date'}}/>
                <TableColumn width="10" headers="acoes" action>
                    <LinkAction icone="remove_red_eye" type="table" to={"/admin/formulario/" + data.id} tooltip="Detalhar"/>
                </TableColumn>
            </tr>
        );
    }

    handleSubmitFiltro = e => {
        e.preventDefault()
        this.getForms('/forms?size=10');
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    getTools(){
        return(
            <LinkAction icone="add" type="icon" to="/admin/formulario/novo" tooltip="Novo Formulário" color="light-grey"/>
        )
    }

    render() {
        return (
            <div>
                <Table  title="Listar Formulários"
                        summary="Listagem de Formulários no sistema."
                        url={this.state.url}
                        data={this.state.data}
                        dataMapper={this.dataMapper}
                        onPaginator={this.onPaginator}
                        onFilter={this.onFilter}
                        tools={this.getTools()}
                        displayLoading={this.state.activeLoader}
                        card noPadding/>
            </div>
        );
    }
}

export default ListAllForm;


// WEBPACK FOOTER //
// ./src/view/formulario/list/ListAllForm.js